// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605210803/js/" + chunkId + "." + {"44":"dfd1ec06","225":"c6e66f96","481":"fb15c7aa","486":"69299c7c","770":"9fa63183"}[chunkId] + ".0.40324783094483774.chunk.js";
};